import THEME from "../../../theme";
import { fs } from "../utils/styles";

const geld = (n) => `${n >= 0 ? "+" : ""}${n.toFixed(2)} €`;

export default function GroessteVeraenderungen({ steigendeKosten, sinkendeEinnahmen }) {
  if (steigendeKosten.length === 0 && sinkendeEinnahmen.length === 0) return null;
  return (
    <div style={fs.karte}>
      <h3 style={{ color: THEME.colors.text, marginTop: 0 }}>Warum hat sich der Gewinn verändert?</h3>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 20 }}>
        <div>
          <p style={{ color: THEME.colors.textMuted, fontSize: THEME.fontSize.sm, fontWeight: 600, textTransform: "uppercase" }}>Steigende Ausgaben</p>
          {steigendeKosten.length === 0 && <p style={{ color: THEME.colors.textMuted, fontSize: THEME.fontSize.sm }}>Keine.</p>}
          {steigendeKosten.map(k => (
            <div key={k.kategorie} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderTop: `1px solid ${THEME.colors.border}` }}>
              <span style={{ color: THEME.colors.text }}>{k.kategorie}</span>
              <span style={{ color: THEME.colors.danger }}>{geld(k.veraenderung)}</span>
            </div>
          ))}
        </div>
        <div>
          <p style={{ color: THEME.colors.textMuted, fontSize: THEME.fontSize.sm, fontWeight: 600, textTransform: "uppercase" }}>Sinkende Einnahmen</p>
          {sinkendeEinnahmen.length === 0 && <p style={{ color: THEME.colors.textMuted, fontSize: THEME.fontSize.sm }}>Keine.</p>}
          {sinkendeEinnahmen.map(k => (
            <div key={k.kategorie} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderTop: `1px solid ${THEME.colors.border}` }}>
              <span style={{ color: THEME.colors.text }}>{k.kategorie}</span>
              <span style={{ color: THEME.colors.warning }}>{geld(k.veraenderung)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
